/* S11: SP ドロワー（snippets/tol-header-drawer.liquid）の tol 拡張。Dawn 本体無改修・tol- 隔離。
   MenuDrawer は header-drawer 内の全 summary / 全 button にリスナーを直接 bind する
   （assets/global.js:433-440）。凍結のインラインアコーディオン（ネイティブ details）には
   サブメニュー機構（スライドパネル + trapFocus 前提・global.js:453-482）が非互換のため、
   祖先 capture（ターゲット段より必ず先行）で click を先取りし、ネイティブ動作だけを残す。 */
(() => {
  const init = (root) => {
    const drawer = root.querySelector('header-drawer');
    if (!drawer || drawer.dataset.tolDrawerInit) return;
    const panel = drawer.querySelector('#menu-drawer');
    const mainDetails = drawer.querySelector('#Details-menu-drawer-container');
    const mainSummary = mainDetails && mainDetails.querySelector(':scope > summary');
    if (!panel || !mainSummary) return;
    drawer.dataset.tolDrawerInit = 'true';

    panel.addEventListener(
      'click',
      (event) => {
        // アコーディオン summary: MenuDrawer.onSummaryClick を遮断（details のネイティブ
        // トグルは default action のため生きる）。メイン summary は #menu-drawer の兄弟なので
        // ここには到達しない。
        if (event.target.closest('summary')) event.stopPropagation();
        // dz-top の ✕: onCloseButtonClick（closeSubmenu）では body スクロールロックが解除
        // されないため、メイン summary の click（closeMenuDrawer の完全経路）へ転送する。
        if (event.target.closest('[data-tol-drawer-close]')) {
          event.stopPropagation();
          mainSummary.click();
        }
        // ds04 #74: 同じページ内のアンカー（例: /account/login 上の会員登録 = #section1）は
        // ページ遷移しないためドロワーが開いたまま残る。✕ と同じ完全経路で閉じてから、
        // リンクのネイティブのスクロールに任せる（preventDefault しない）。
        const link = event.target.closest('a[href*="#"]');
        if (link && link.hash && link.origin === location.origin && link.pathname === location.pathname && link.search === location.search) {
          mainSummary.click();
        }
      },
      true
    );

    // aria-expanded の常時同期。global.js:71-85 の binder（子孫セレクタ＝アコーディオン
    // summary にも初期値を付与）と Esc 経路（closeSubmenu = global.js:527）のスタンプは、
    // click 遮断下では更新されず stale 化するため、toggle（非バブル → capture で束ねる）が正を持つ。
    panel.addEventListener(
      'toggle',
      (event) => {
        const summary = event.target.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', event.target.hasAttribute('open'));
      },
      true
    );

    // WCAG 2.4.11: openMenuDrawer の初期フォーカスは panel に隠れたメイン summary に乗るため
    // ✕ へ転送する。menu-opening 付与（setTimeout 0）前は visibility:hidden で focus 不可 → rAF×2。
    mainDetails.addEventListener('toggle', () => {
      if (!mainDetails.hasAttribute('open')) return;
      requestAnimationFrame(() =>
        requestAnimationFrame(() => {
          const close = panel.querySelector('[data-tol-drawer-close]');
          if (close && mainDetails.hasAttribute('open')) close.focus();
        })
      );
    });
  };

  init(document);
  // テーマエディタのセクション再描画対応（本番ストアフロントでは発火しない）
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
